import { Pipe, PipeTransform } from "@angular/core";
import { ThousandizePipe } from "ev-core";

@Pipe({
    name: 'pluralizer',
    standalone: true
})
export class PluralizerPipe implements PipeTransform {
    transform(number: unknown, singular: string, plural: string): string {
        return PluralizerPipe.transform(number, singular, plural);
    }
    static transform(number: unknown, singular: string, plural: string): string {

        const text = number === 1 ? singular : plural;
        const value = ThousandizePipe.transform(number);

        return value === "-" ? value : value + " " + text;
    }
}